import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `Menu` — three horizontal lines (hamburger).
 *
 * Canonical use: open side nav, show menu options.
 * Aria label:    Menu (hamburger)
 * Family:        ui-controls
 * Related:       chevron-right, chevron-left, chevron-up, chevron-down, chevrons-right, chevrons-left
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Menu (hamburger).
 *
 */
export const Menu = forwardRef(function Menu(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("path", { d: "M4 6h16" }), _jsx("path", { d: "M4 12h16" }), _jsx("path", { d: "M4 18h16" })] }));
});
//# sourceMappingURL=menu.js.map